const formatStops = (legs) =>
  ({
    1: 'Direct',
    2: '1 stop',
  })[legs] || `${legs - 1} stops`;

export default formatStops;
